// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"
import * as bootstrap from "bootstrap"

ActiveStorage.start()

// Custom Turbo Stream action: redirect via turbo_stream.action(:redirect, path)
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}
